// video-carousel.js

document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.carousel-track');
  if (!track) return; // Safeguard if snippet isn't on the page

  const items = Array.from(track.querySelectorAll('.carousel-item'));
  const leftControl = document.querySelector('.carousel-control-left');
  const rightControl = document.querySelector('.carousel-control-right');
  const itemWidth = items[0].getBoundingClientRect().width; 
  // or compute from CSS for dynamic sizing

  // We'll track which "slide group" is visible
  let currentIndex = 0;
  const itemsToShow = 3; // how many items are shown at a time
  const totalItems = items.length;
  // The number of 'slide steps' we can have
  const maxIndex = totalItems - itemsToShow;

  // Set initial transform
  updateCarousel();

  // Arrow click handlers
  leftControl.addEventListener('click', () => {
    currentIndex = Math.max(0, currentIndex - 1);
    updateCarousel();
  });

  rightControl.addEventListener('click', () => {
    currentIndex = Math.min(maxIndex, currentIndex + 1);
    updateCarousel();
  });

  // Utility function to update the track position
  function updateCarousel() {
    const amountToMove = itemWidth * currentIndex + 10 * currentIndex; 
    // "10" here accounts for the padding if needed. 
    // Adjust or compute from actual item widths+padding.
    track.style.transform = `translateX(-${amountToMove}px)`;
  }

  // Play button logic
  const playButtons = document.querySelectorAll('.play-button');
  playButtons.forEach((button, idx) => {
    const video = items[idx].querySelector('video');
    button.addEventListener('click', () => {
      // Start the video
      video.play();
      // Optionally hide the play button when playing
      button.style.display = 'none';

      // Show the button again when video is paused or ended
      video.addEventListener('pause', () => {
        button.style.display = 'block';
      });
      video.addEventListener('ended', () => {
        button.style.display = 'block';
      });
    });
  });
});
